/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { FC, PropsWithChildren, createContext, useState } from 'react';

export type SessionDialogFormType = 'signIn' | 'register' | 'forgot-password' | null;
export type SessionDialogContextType = {
	selectedForm: SessionDialogFormType;
	setSelectedForm: (state: SessionDialogFormType) => void;
	sessionDialogOpen: boolean;
	setSessionDialogOpen: (state: boolean) => void;
};

export const SessionDialogContext = createContext<SessionDialogContextType>(
	{} as SessionDialogContextType
);

export const SessionDialogProvider: FC<PropsWithChildren> = ({ children }) => {
	const [sessionDialogOpen, setSessionDialogOpen] = useState<boolean>(false);
	const [selectedForm, setSelectedForm] = useState<SessionDialogFormType>(null);
	return (
		<SessionDialogContext.Provider
			value={{ sessionDialogOpen, setSessionDialogOpen, selectedForm, setSelectedForm }}
		>
			{children}
		</SessionDialogContext.Provider>
	);
};
